import React from "react";
import { Controller, useForm } from "react-hook-form";
import { AccountType } from "../../../../core/api/models";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { DropdownList, Multiselect } from "react-widgets";
import {
  convertPascalCaseToWords,
  WhatsappLeadAssignmentSettings,
} from "../../../../core";

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: WhatsappLeadAssignmentSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: WhatsappLeadAssignmentSettings;
  error?: string;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<WhatsappLeadAssignmentSettings>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const renderUserType = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          Lead Assigned User type
        </label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                name="userType"
                defaultValue={props.data?.userType}
                render={({ onChange, value, name }) => (
                  <DropdownList
                    value={value}
                    data={[
                      ...[{ label: "Unassigned", value: null }],
                      ...Object.keys(AccountType).map((key) => {
                        return {
                          label: convertPascalCaseToWords(key === "CallCenterExecutive" ? "BusinessDeveloperExecutive" : key === "Agent" ? "TransactionExecutive" : key),
                          value: key,
                        };
                      }),
                    ]}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select User type"}
                    onChange={(val) => {
                      onChange(val.value);
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.userType && (
                <ErrorMessage>User Type is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderAccountTypes = () => {
    return (
      <div className="col-12">
        <label className="font-sm text-uppercase">
          Email Notification Send To<span className="text-danger">*</span>
        </label>
        <div className="row">
          <div className="col-12">
            <div className="form-group font-weight-semibold mb-3">
              <Controller
                control={control}
                rules={{
                  required: true,
                  validate: (value) => {
                    return !!(value.length > 0);
                  },
                }}
                name="accountTypes"
                defaultValue={props.data?.accountTypes}
                render={({ onChange, value, name }) => (
                  <Multiselect
                    value={value}
                    data={Object.keys(AccountType).map((key) => {
                      return {
                        label: convertPascalCaseToWords(key === "CallCenterExecutive" ? "BusinessDeveloperExecutive" : key === "Agent" ? "TransactionExecutive" : key),
                        value: key,
                      };
                    })}
                    defaultValue={value}
                    textField={"label"}
                    valueField={"value"}
                    placeholder={"Select Transaction Manager Types"}
                    onChange={(val) => {
                      onChange(val?.map((x) => x.value));
                    }}
                    allowCreate="onFilter"
                    autoFocus={true}
                  />
                )}
              />
              {errors.accountTypes && (
                <ErrorMessage>Account Types Types is required</ErrorMessage>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Whatsapp Lead Assignment Settings
        </h4>
        <div className="row gutter-10">
          {renderUserType()}
          {renderAccountTypes()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
